/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';

import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as fromUserNewVideosActions from 'app/shared/store/actions/user-new-videos.action';
import { UserNewVideosService } from 'app/shared/services';

@Injectable()
export class UserNewVideosEffects {
  getUserNewVideos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromUserNewVideosActions.LOAD_USER_NEW_VIDEOS),
      switchMap((action: fromUserNewVideosActions.LoadUserNewVideos) => {
        return this.userNewVideosService.getUserNewVideosByUserId(action.payload).pipe(
          map((response) => {
            return new fromUserNewVideosActions.LoadUserNewVideosSuccess(response);
          }),
          catchError((error) => {
            return of(new fromUserNewVideosActions.LoadUserNewVideosFail(error));
          })
        );
      })
    )
  );

  deleteUserNewVideos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromUserNewVideosActions.DELETE_USER_NEW_VIDEOS),
      switchMap((action: fromUserNewVideosActions.DeleteUserNewVideos) => {
        return this.userNewVideosService.deleteUserNewVideo(action.payload).pipe(
          map((response) => {
            return new fromUserNewVideosActions.DeleteUserNewVideosSuccess(action.payload);
          }),
          catchError((error) => {
            return of(new fromUserNewVideosActions.LoadUserNewVideosFail(error));
          })
        );
      })
    )
  );

  addUserNewVideos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromUserNewVideosActions.ADD_USER_NEW_VIDEOS),
      switchMap((action: fromUserNewVideosActions.AddUserNewVideos) => {
        return this.userNewVideosService.addUserNewVideo(action.payload).pipe(
          map((response) => {
            return new fromUserNewVideosActions.AddUserNewVideosSuccess(response);
          }),
          catchError((error) => {
            return of(new fromUserNewVideosActions.LoadUserNewVideosFail(error));
          })
        );
      })
    )
  );

  constructor(private actions$: Actions, private userNewVideosService: UserNewVideosService) {}
}
